import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function imsAuditChecklist() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist",
        method: 'GET'
    });
}

export function imsAuditChecklistRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateImsAuditChecklist(record) {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteImsAuditChecklist(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function addImsAuditChecklistRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}
